<template>
  <el-card>
    <div style="margin-bottom:16px;">
      <el-button type="primary" @click="openCreate">新增Banner</el-button>
    </div>
    <el-table :data="rows" border>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="imageUrl" label="图片预览" width="150">
        <template slot-scope="scope">
          <img v-if="scope.row.imageUrl" :src="scope.row.imageUrl" style="width:120px;height:60px;object-fit:cover;border-radius:4px;" />
        </template>
      </el-table-column>
      <el-table-column prop="imageUrl" label="图片地址" show-overflow-tooltip />
      <el-table-column prop="linkType" label="跳转类型" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.linkType === 'none'">无跳转</span>
          <span v-else-if="scope.row.linkType === 'page'">页面路径</span>
          <span v-else-if="scope.row.linkType === 'url'">外部链接</span>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="权重" width="80" />
      <el-table-column label="启用" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isActive ? 'success' : 'info'" size="small">
            {{ scope.row.isActive ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="visible" title="Banner 编辑" width="600px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="图片">
          <el-upload
            :action="uploadAction"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            accept="image/*"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持 jpg/png/gif 格式，建议尺寸 750x300</div>
          </el-upload>
          <el-input v-model="form.imageUrl" placeholder="或直接输入图片URL" style="margin-top:10px;" />
          <div v-if="form.imageUrl" style="margin-top:10px;">
            <img :src="form.imageUrl" style="max-width:100%;border-radius:4px;border:1px solid #dcdfe6;" />
          </div>
        </el-form-item>
        
        <el-form-item label="跳转类型">
          <el-select v-model="form.linkType" placeholder="请选择" style="width:100%;">
            <el-option label="无跳转" value="none" />
            <el-option label="页面路径" value="page" />
            <el-option label="外部链接" value="url" />
          </el-select>
        </el-form-item>
        
        <el-form-item label="跳转值" v-if="form.linkType !== 'none'">
          <el-input v-model="form.linkValue" placeholder="根据跳转类型填写页面路径或URL" />
        </el-form-item>
        
        <el-form-item label="权重">
          <el-input-number v-model="form.weight" :min="0" style="width:100%;" />
        </el-form-item>
        
        <el-form-item label="启用">
          <el-switch v-model="form.isActive" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      
      <span slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { getBannerList, saveBanner, updateBanner, deleteBanner } from '@/api'

export default {
  data () {
    return {
      rows: [],
      visible: false,
      form: {},
      uploadAction: '/api/file/upload',
      uploadHeaders: {}
    }
  },
  created () {
    this.loadData()
    const token = localStorage.getItem('admin_token')
    if (token) {
      this.uploadHeaders.Authorization = `Bearer ${token}`
    }
  },
  methods: {
    async loadData () {
      const res = await getBannerList()
      this.rows = res.data || []
    },
    openCreate () {
      this.form = { 
        imageUrl: '', 
        linkType: 'none', 
        linkValue: '', 
        weight: 0, 
        isActive: 1, 
        startAt: 0, 
        endAt: 9999999999999 
      }
      this.visible = true
    },
    edit (row) {
      this.form = { ...row }
      this.visible = true
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    handleUploadSuccess (response) {
      if (response.code === 0 && response.data) {
        this.form.imageUrl = response.data.url
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },
    async submit () {
      if (!this.form.imageUrl) {
        this.$message.error('请上传图片')
        return
      }
      try {
        if (this.form.id) {
          await updateBanner(this.form.id, this.form)
        } else {
          await saveBanner(this.form)
        }
        this.$message.success('保存成功')
        this.visible = false
        this.loadData()
      } catch (error) {
        this.$message.error(error.message || '保存失败')
      }
    },
    async remove (row) {
      try {
        await this.$confirm('确认删除该 Banner?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteBanner(row.id)
        this.$message.success('已删除')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
